import { render, staticRenderFns } from "./OtherFilters.vue?vue&type=template&id=4c881d08&scoped=true"
import script from "./OtherFilters.vue?vue&type=script&lang=js"
export * from "./OtherFilters.vue?vue&type=script&lang=js"
import style0 from "./OtherFilters.vue?vue&type=style&index=0&id=4c881d08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c881d08",
  null
  
)

export default component.exports